module.exports = __webpack_public_path__ + "img/CellCycle-PRCA_10X_ACC.4ea5c523.png";